import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import React, { useRef } from "react";
import emailjs from "@emailjs/browser";

function ContactForm() {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_a0t6tn8",
        "template_849m0ph",
        form.current,
        "mHnpvGxALldJj-mOF"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
  };
  return (
    <section className="contact-form">
      <form ref={form} onSubmit={sendEmail}>
        <div className="textInputWrapper">
          <label>Name</label>
          <input type="text" name="user_name" />
        </div>
        <div className="textInputWrapper">
          <label>Email</label>
          <input type="email" name="user_email" />
        </div>
        <div className="textInputWrapper">
          <label>Subject</label>
          <input type="text" name="subject" />
        </div>
        <div className="textInputWrapper message">
          <label>Message</label>
          <textarea name="message" />
        </div>
        <div className="textInputWrapper submit-btn">
          <input type="submit" value="Send" />
        </div>
      </form>
    </section>
  );
}

//create a todo list

export default ContactForm;
